import type { FaireProductEntity } from "../../entity_types/product";

export const p_ks2779fybv: FaireProductEntity = {
  token: "p_ks2779fybv",
  type: "product",
  name: "Oyster Shell Nautical Coastal Beach Ocean Kitchen Towel",
  brandName: "Canary Road",
  imageUrl:
    "https://cdn.faire.com/fastly/b093a6768ed264bf531add981d5bf5c5df7d93140e9242ab3757739e9be511d4.jpeg",
  priceDollars: 8,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/84c38a84400bdf0dbf8134f1bf93e31854e6d2d2f41f77cfd3494de784343d99.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
